import mixinProps from './mixin-props.js';

const mixin = {
  ...mixinProps,

  computed: {
    sections() {
      return this.$store.state.sections;
    },

    sectionData() {
      return (
        this.sections &&
        this.sections.filter((item) => item.code == this.section)[0]
      );
    },

    subsectionData() {
      return (
        this.sectionData &&
        this.sectionData.children &&
        this.sectionData.children.filter(
          (item) => item.code == this.subsection,
        )[0]
      );
    },

    eventsList() {
      if (!this.state && !Array.isArray(this.state.events)) return [];
      return this.state.events.map((data) => ({
        ...data,
        // badge: this.dataModule,
      }));
    },

    mapPointList() {
      return this.state.mapPoints;
    },

    title() {
      return this.subsectionData
        ? this.subsectionData.name
        : this.sectionData
        ? this.sectionData.name
        : '';
    },

    keywords() {
      return '';
    },

    description() {
      return '';
    },
  },

  metaInfo() {
    let title = this.title || this.name;
    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
      ],
    };
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/pages/event/mixin-list.js